import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import ConditionLogicBox from '../common/ConditionLogicBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerConditionsGroupConditionsCondition = ({
  usingWidePanel,
  hasLogicBox,
  logicOperator,
  children,
  hideOperator
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: usingWidePanel ? 'row' : 'column',
    gap: "100",
    children: [hasLogicBox && /*#__PURE__*/_jsx(ConditionLogicBox, {
      logicOperator: logicOperator,
      hideOperator: hideOperator
    }), /*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      minInlineSize: "0",
      children: children
    })]
  });
};
export default ViewerConditionsGroupConditionsCondition;